// test1497
(1497 && 0);
